import { render, staticRenderFns } from "./DistributionsFilter.vue?vue&type=template&id=3ddd8f74&"
import script from "./DistributionsFilter.vue?vue&type=script&lang=ts&"
export * from "./DistributionsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports